export default __webpack_public_path__ + "static/media/photo--lg--40.8aaa8fb4.jpg";